'use strict';

var fragt = fragt || {};
var novicell = novicell || {};

fragt.overlay = fragt.overlay || new function () {
    var self = this;

    this.init = function () {
        // Waiting for the DOM to load
        // Select your overlay trigger
        var triggers = document.querySelectorAll('.js-overlay-trigger');

        for (var i = 0; i < triggers.length; i++) {
            triggers[i].addEventListener('click', function (e) {
                e.preventDefault();
                var currentTrigger = e.target;
                novicell.overlay.create({
                    'selector': currentTrigger.getAttribute('data-element'),
                    'class': 'selector-overlay'
                });
            });
        }
        
        // Video overlay
        var videoOverlayTriggers = document.querySelectorAll('.js-video-overlay-trigger');
        for (var j = 0; j < videoOverlayTriggers.length; j++) {
            videoOverlayTriggers[j].addEventListener('click', function (event) {
                self.openVideoOverlay(event);
            }); 
        }
    };

    this.openVideoOverlay = function (event) {
        event.preventDefault();
        var currentTrigger = event.target;

        novicell.overlay.create({
            'videoId': currentTrigger.getAttribute('data-video-id'),
            'type': currentTrigger.getAttribute('data-type'),
            'class': 'video-overlay',
            'autoplay': 1
        });
    };
}();
